// src/pages/stylist/ReviewAddOnsPage.tsx
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../../styles/ReviewAddOnsPage.css';

const ReviewAddOnsPage: React.FC = () => {
  const { shortCode: appointmentId } = useParams<{ shortCode: string }>();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(`/stylist/appointment/${appointmentId}`);
  };

  return (
    <div className="review-addons-page">
      <header className="review-addons-page__header">
        <button type="button" className="review-addons-page__back" onClick={handleBack} aria-label="Back">
          ← Back
        </button>
        <h1 className="review-addons-page__title">Add-ons</h1>
      </header>
      <div className="review-addons-page__empty">
        <p className="review-addons-page__empty-title">All set!</p>
        <p className="review-addons-page__empty-text">Add-ons no longer use approval status. All add-ons are included in the appointment.</p>
        <button type="button" className="review-addons-page__back" onClick={handleBack}>
          Back to Appointment
        </button>
      </div>
    </div>
  );
};

export default ReviewAddOnsPage;
